import React, { useState, useEffect, useRef } from "react";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { useNavigate, useLocation, UNSAFE_NavigationContext } from "react-router-dom";

const message = `There are some unsaved changes ?`;

const ConfirmRouteChange = (props) => {
  const { isFormDirty, setIsformDirty } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const { navigator } = React.useContext(UNSAFE_NavigationContext);

  const [
    shouldRouteChangeConfirmationPopUpVisible,
    setShouldRouteChangeConfirmationPopUpVisible,
  ] = useState(false);

  const [nextLocation, setNextLocation] = useState(null);
  const confirmedNavigationRef = useRef(false);
  const originalPushRef = useRef(null);
  const originalReplaceRef = useRef(null);

  useEffect(() => {
    if (!isFormDirty) return;

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
      return "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isFormDirty]);

  useEffect(() => {
    if (!navigator) return;

    if (!originalPushRef.current) {
      originalPushRef.current = navigator.push;
    }
    if (!originalReplaceRef.current) {
      originalReplaceRef.current = navigator.replace;
    }

    if (!isFormDirty || confirmedNavigationRef.current) {
      navigator.push = originalPushRef.current;
      navigator.replace = originalReplaceRef.current;
      return;
    }

    navigator.push = (tx, location, opts) => {
      
      if (isFormDirty && !confirmedNavigationRef.current) {
        setNextLocation(tx);
        setShouldRouteChangeConfirmationPopUpVisible(true);
        return;
      }
      return originalPushRef.current.call(navigator, tx, location, opts);
    };

    navigator.replace = (tx, location, opts) => {
      
      if (isFormDirty && !confirmedNavigationRef.current) {
        setNextLocation(tx);
        setShouldRouteChangeConfirmationPopUpVisible(true);
        return;
      }
      
      return originalReplaceRef.current.call(navigator, tx, location, opts);
    };

    return () => {
      if (originalPushRef.current) {
        navigator.push = originalPushRef.current;
      }
      if (originalReplaceRef.current) {
        navigator.replace = originalReplaceRef.current;
      }
    };
  }, [isFormDirty, navigator]);

  const handleStay = () => {
    setShouldRouteChangeConfirmationPopUpVisible(false);
    setNextLocation(null);
  };

  const handleLeave = () => {
    setShouldRouteChangeConfirmationPopUpVisible(false);
    setNextLocation(null);
    
    if (nextLocation) {
      confirmedNavigationRef.current = true;
      
      setIsformDirty(false);
      const path = nextLocation.pathname + (nextLocation.search || '') + (nextLocation.hash || '');
      
      setTimeout(() => {
        navigate(path);
        setNextLocation(null);
        setTimeout(() => {
          confirmedNavigationRef.current = false;
        }, 100);
      }, 0);
    }
  };

  return (
    <>
      <ConfirmDialog
        visible={shouldRouteChangeConfirmationPopUpVisible}
        message={message}
        header="Are you sure want to leave ?"
        position={"top"}
        onHide={handleStay}
        style={{ width: "90vw", maxWidth: "450px" }}
        breakpoints={{ "960px": "75vw", "640px": "90vw" }}
        footer={
          <div className="confirm-route-footer">
            <Button
              label="Leave"
              icon="pi pi-exclamation-triangle"
              className="p-button-sm p-button-danger"
              onClick={handleLeave}
            />
            <Button
              label="Stay"
              className="p-button-sm p-button-raised"
              onClick={handleStay}
            />
          </div>
        }
      />
    </>
  );
};

export default ConfirmRouteChange;